import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  ViewChild
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDatepicker, MatDatepickerInputEvent } from '@angular/material/datepicker';
import { formatDate } from '../../../core';

@Component({
  standalone: false,
  selector: 'app-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.scss']
})
export class CalendarComponent implements OnChanges {
  @Input() id: string;
  @Input() typeCall: string;
  @Input() value: any;
  @Input() minDate: Date;
  @Input() maxDate: Date;
  @Input() availableDates: string[] = [];
  @Input() disabled = false;
  @Input() isLoading = false;
  @Input() dateError: string;
  @Input() opened = false;
  @Output() update = new EventEmitter<Date>();
  @Output() loadDates = new EventEmitter<boolean>();
  @ViewChild('picker1') private picker1: MatDatepicker<Date>;
  date = new FormControl(new Date());
  constructor() { }


  ngOnChanges() {
    this.date.setValue(this.value);
    if (this.opened) {
      this.picker1.open();
    }
  }


  myFilter = (d: Date | null): boolean => {
    if (!d) {
      return false;
    }

    if (!this.availableDates || this.availableDates.length === 0) {
      return true;
    }

    const formatted = formatDate(d);

    return this.availableDates.includes(formatted);
  };

  addEvent(event: MatDatepickerInputEvent<Date>) {
    this.update.emit(event.value);
  }

  loadDatesAvailables() {
    if (this.availableDates && this.availableDates.length && this.availableDates.length === 1) {
      this.picker1.close();
      this.loadDates.emit(true);
    }
  }
}
